// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"580":"55dc1642","633":"423035d4","780":"6f1131db","782":"c7373fc2"}[chunkId] + ".chunk.css";
};